import { i18n } from '@/shared/i18n';

export interface EmojiGroup {
  id: string;
  label: string;
  emojis: string[];
}

// Getters, not values: this array is built while the module is evaluated, so resolving per
// read is what lets a label follow a language change instead of freezing at import.
export const EMOJI_GROUPS: EmojiGroup[] = [
  {
    id: 'smileys',
    get label() {
      return i18n.t('common:ui.emojiPicker.smileys');
    },
    emojis: [
      '😀',
      '😃',
      '😄',
      '😁',
      '😆',
      '😅',
      '🤣',
      '😂',
      '🙂',
      '🙃',
      '😉',
      '😊',
      '😇',
      '🥰',
      '😍',
      '🤩',
      '😘',
      '😗',
      '☺️',
      '😚',
      '😙',
      '😋',
      '😛',
      '😜',
      '🤪',
      '😝',
      '🤔',
      '🤗',
      '🤭',
      '😎',
      '🥳',
      '😏',
    ],
  },
  {
    id: 'gestures',
    get label() {
      return i18n.t('common:ui.emojiPicker.gestures');
    },
    emojis: [
      '👍',
      '👎',
      '👌',
      '🤌',
      '🤏',
      '✌️',
      '🤞',
      '🤟',
      '🤘',
      '🤙',
      '👈',
      '👉',
      '👆',
      '👇',
      '👋',
      '🙌',
      '🙏',
      '💪',
      '👏',
      '🫡',
    ],
  },
  {
    id: 'hearts',
    get label() {
      return i18n.t('common:ui.emojiPicker.hearts');
    },
    emojis: [
      '❤️',
      '🧡',
      '💛',
      '💚',
      '💙',
      '💜',
      '🖤',
      '🤍',
      '🤎',
      '💔',
      '❤️‍🔥',
      '💖',
      '💕',
      '💞',
      '💓',
      '💗',
    ],
  },
  {
    id: 'objects',
    get label() {
      return i18n.t('common:ui.emojiPicker.objects');
    },
    emojis: [
      '🔥',
      '✨',
      '⭐',
      '🎉',
      '💯',
      '✅',
      '❌',
      '⚠️',
      '❓',
      '❗',
      '💡',
      '📌',
      '📎',
      '🚀',
      '☕',
      '🎯',
      '🐛',
      '🛠️',
      '📝',
      '🔖',
      '🏆',
      '💬',
      '👀',
      '🤝',
    ],
  },
];
